// extracted by mini-css-extract-plugin
module.exports = {"skeletonCirclesList":"SkeletonCirclesList_skeletonCirclesList__1lk0x","skeletonCirclesListItem":"SkeletonCirclesList_skeletonCirclesListItem__U5ZeQ"};